import { useEffect } from 'react';
import { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { appVersion } from '../../../environment';
import { useAxios } from '../../axios';

export const useAppVersionInterceptor = (): void => {
    const axios = useAxios();

    useEffect(() => {
        const appVersionInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
            if (config.headers) {
                config.headers.AppVersion = appVersion || '';
            }

            return config;
        };

        const appVersionResponseInterceptor = (error: AxiosError): Promise<void> => {
            if (
                error.response != null &&
                error.response.status === 400 &&
                typeof error.response.data === 'string'
            ) {
                const msg = error.response.data as string;
                if (msg?.startsWith('Version validation problem')) {
                    window.location.reload();
                    return Promise.resolve();
                }
            }

            return Promise.reject(error);
        };

        const reqInterceptor = axios.interceptors.request.use(appVersionInterceptor);
        const responeInterceptor = axios.interceptors.response.use(
            (response) => response,
            appVersionResponseInterceptor
        );

        return () => {
            if (reqInterceptor) {
                axios.interceptors.request.eject(reqInterceptor);
            }

            if (responeInterceptor) {
                axios.interceptors.response.eject(responeInterceptor);
            }
        };
    }, [axios.interceptors.request, axios.interceptors.response]);
};
